<template>
	<div>
		<v-combobox
		v-model="selected_retailer"
		:items="retailer_list"
		item-text="retailer_firm_name"
		item-value="retailer_id"
		:label="$lang.RETAILER"
		:placeholder="$lang.RETAILER"
		@focus="retailerAutoComplete"
		@keydown="retailerAutoComplete"
		@change="updateRetailer"
		:search-input.sync="retailer_serch_query"
		append-icon="mdi-menu-down"
		single-line
		outlined
		clearable
		dense
		:rules="$rules.reatilerRule"
		:loading="loading"
		>
		<template v-slot:item="data">
			<v-list-item-content>
				<v-list-item-title v-html="data.item.retailer_firm_name"></v-list-item-title>
				<v-list-item-subtitle >{{data.item.retailer_city}},{{data.item.retailer_state}}</v-list-item-subtitle>
			</v-list-item-content>
		</template>

	</v-combobox> 		
</div>
</template>
<script type="text/javascript">

export default {
	props:['retailer'],
	data () {
		return {
			loading:false,	
			retailer_list:[],
			retailer_serch_query:"",
			selected_retailer:null
		}
	},
	methods:{
		updateRetailer(){
			let new_retailer=this.retailer
			new_retailer=this.selected_retailer
			
			this.$emit("update-retailter", new_retailer);

		},
		retailerAutoComplete(){
			const self=this
			let params={
				"search_query":self.retailer_serch_query,
			};
			self.loading=true;
			const successHandler = (response) => {
				console.log(response)
				self.retailer_list=response.data.retailer_list

			};
			const finallyHandler = () => {
				self.loading=false
			};
			self.request_GET( self,self.$urls.RETAILER_LIST,params,successHandler,null,null,finallyHandler,true)


		}
	}
}
</script>